import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Portal';

const portal = [
  {
    matchRegex: '/Portal',
    name: getRouteName(MODULE_NAME, 'Users'),
    slots: [SLOT_KEY.SLOT_ADDITION_MENU],
  },
  {
    matchRegex: '/Portal/Role',
    name: getRouteName(MODULE_NAME, 'Roles'),
    slots: [SLOT_KEY.SLOT_ADDITION_MENU],
  },
  {
    matchRegex: '/Portal/CreateRole',
    name: getRouteName(MODULE_NAME, 'Create Roles'),
    slots: [SLOT_KEY.SLOT_ADDITION_MENU],
  },
  {
    matchRegex: '/Portal/Create',
    name: getRouteName(MODULE_NAME, 'Add User'),
    slots: [SLOT_KEY.SLOT_ADDITION_MENU],
  },
];

export default portal;
